import { render, staticRenderFns } from "./AboutSnackbar.vue?vue&type=template&id=8ace8100&"
import script from "./AboutSnackbar.vue?vue&type=script&lang=js&"
export * from "./AboutSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports